// extracted by mini-css-extract-plugin
export default {"container":"container__VLX09","icon":"icon__wtrjP","text":"text__XrBLe","title":"title__t1WqS","subtitle":"subtitle__4IHVC"};